import type { Author } from "../types/comic";

export const authors: Author[] = [
  {
    id: "linchuan",
    name: "林川",
    avatar:
      "https://readdy.ai/api/search-image?query=Portrait%20illustration%20of%20a%20calm%20young%20male%20comic%20artist%20with%20glasses%20and%20short%20black%20hair%20in%20a%20simple%20studio%2C%20soft%20green%20background%2C%20modern%20anime%20art%20style%2C%20clean%20simple%20background%2C%20vivid%20colors%2C%20no%20text&width=400&height=400&seq=waman-author-linchuan&orientation=squarish",
    bio: "科幻系作者，擅长用冷色调讲述温暖的故事。曾在航天工程行业工作五年，画里的每一处轨道和推进器都来自真实资料。代表作《星海彼端的约定》《机械纪元》。她说，宇宙很大，但人心更大一些。",
    workIds: ["xinghai", "jixie"],
    followers: "42.6万",
    location: "上海",
    style: "硬科幻 · 情感线",
  },
  {
    id: "sumoli",
    name: "苏墨离",
    avatar:
      "https://readdy.ai/api/search-image?query=Portrait%20illustration%20of%20an%20elegant%20young%20woman%20comic%20artist%20with%20long%20dark%20hair%20and%20a%20red%20hairpin%2C%20soft%20warm%20background%2C%20modern%20anime%20art%20style%2C%20clean%20simple%20background%2C%20vivid%20colors%2C%20no%20text&width=400&height=400&seq=waman-author-sumoli&orientation=squarish",
    bio: "古风与奇幻题材作者，笔下的妖怪既有仙气也有人味。喜欢在深夜画灯笼和雨，认为最好的幻想都长在现实的缝隙里。代表作《妖狐夜行录》《山海食堂》。",
    workIds: ["yaohu", "shanhai"],
    followers: "38.1万",
    location: "杭州",
    style: "东方奇幻 · 古风",
  },
  {
    id: "chenyao",
    name: "陈曜",
    avatar:
      "https://readdy.ai/api/search-image?query=Portrait%20illustration%20of%20a%20confident%20young%20male%20comic%20artist%20with%20messy%20hair%20and%20a%20hoodie%2C%20cool%20teal%20background%2C%20modern%20anime%20art%20style%2C%20clean%20simple%20background%2C%20vivid%20colors%2C%20no%20text&width=400&height=400&seq=waman-author-chenyao&orientation=squarish",
    bio: "都市悬疑与末日题材双线作者，节奏控，最爱在最后一页留一个让人睡不着的反转。代表作《都市灵能事务所》《末日拾荒者》，被读者称为「追更令人上头」。",
    workIds: ["lingneng", "mori"],
    followers: "45.3万",
    location: "成都",
    style: "都市悬疑 · 末世",
  },
  {
    id: "xiayou",
    name: "夏柚",
    avatar:
      "https://readdy.ai/api/search-image?query=Portrait%20illustration%20of%20a%20cheerful%20young%20female%20comic%20artist%20with%20a%20ponytail%20and%20an%20oversized%20sweater%2C%20soft%20peach%20background%2C%20modern%20anime%20art%20style%2C%20clean%20simple%20background%2C%20warm%20vivid%20colors%2C%20no%20text&width=400&height=400&seq=waman-author-xiayou&orientation=squarish",
    bio: "治愈系作者，画风明亮柔软，专治各种下班后的心情不好。坚持每一话都要有一个让人会心一笑的瞬间。代表作《甜点魔法屋》《校园青春纪事》。",
    workIds: ["tiandian", "xiaoyuan"],
    followers: "33.8万",
    location: "厦门",
    style: "治愈日常 · 青春",
  },
  {
    id: "baiwujiu",
    name: "白无咎",
    avatar:
      "https://readdy.ai/api/search-image?query=Portrait%20illustration%20of%20a%20mysterious%20young%20male%20comic%20artist%20with%20silver%20hair%20and%20a%20black%20scarf%2C%20misty%20gray%20green%20background%2C%20modern%20anime%20art%20style%2C%20clean%20simple%20background%2C%20vivid%20colors%2C%20no%20text&width=400&height=400&seq=waman-author-baiwujiu&orientation=squarish",
    bio: "热血与武侠题材作者，动作分镜教科书级别的存在。信奉「好的打斗要让读者喘不上气」。代表作《剑影江湖》《拳王之路》。",
    workIds: ["jianying", "quanwang"],
    followers: "51.9万",
    location: "西安",
    style: "武侠 · 动作热血",
  },
];